import React, { useState, createContext, useContext } from 'react';
import { en } from './en';
import { es } from './es';
type Language = 'en' | 'es';
type Translations = typeof en;
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('en');
  const t = lang === 'en' ? en : es;
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-243">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
export function useT() {
  return useLanguage().t;
}